<template>
    <div class="w-100" style="height: calc(100% - 80px);">
        
        <div id="qr-camera" class="qr-scanner-camera"></div>
        
        <div class="container-fluid bg-light h-100" style="overflow-y: scroll;" v-if="showQRScannerErrorMessage">

            <div class="w-100 text-center"><img src="/images/card/icon-camera-blocked.svg" style="height: 60px; width:60px;" class="mt-8 mb-8"></div>
            <h3 class="mb-4">Kameraåtkomsten är blockerad</h3>

            <div class="qr-instructions android">
                
                <ol>
                    <li class="mb-4"><b>Testa först att stänga ner webappen.</b>
                        <ol>
                            <li>Dra nerifrån på skärmen för att visa appväxlaren i din telefon.</li>
                            <li>Dra förhandsvisningen av Hälsoresurs webapp och släpp längst upp eller tryck på krysset för att avsluta appen.</li>
                            <li>Gå till hemskärmen och starta webappen igen.</li>
                        </ol>
                    
                    <li v-if="isSamsungBrowser"><b>Om kameran fortfarande inte fungerar:</b>
                        <ol>
                            <li>Gå till Inställningar > Appar och leta efter k.halsoresurs.se</li>
                            <li>Tryck behörigheter och aktivera Kamera.</li>
                            <li>Öppna webappen och försök igen.</li>
                        </ol>
                    </li>
                    <li v-else><b>Om kameran fortfarande inte fungerar:</b>
                        <ol>
                            <li>Gå till Chrome-inställningar > Webbplatsinställningar > Kamera</li>
                            <li>Se till att webbplatsen finns under "Tillåt" eller flytta den dit från "Blockerade"</li>
                            <li>Öppna webappen och försök igen.</li>
                        </ol>
                    </li>
                </ol>
            </div>

            <div class="qr-instructions iphone">
                Testa att stänga ner webappen:
                <ol>
                    <li>Dra nerifrån på skärmen för att visa appväxlaren i din telefon.</li>
                    <li>Dra förhandsvisningen av Hälsoresurs webapp och släpp längst upp för att avsluta appen.</li>
                    <li>Gå till hemskärmen och starta webappen igen.</li>
                </ol>

            </div>
        </div>

    </div>
</template>

<script>

import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode'

export default {
    props: {
        qrbox: {
            type: Number,
            default: 300
        },
        fps: {
            type: Number,
            default: 25
        }
    },

    data () {
        return {
            html5QrCode: null,
            showQRScannerErrorMessage:false,
            isSamsungBrowser:false,
        }
    },

    mounted () {
        const config = {
            fps: this.fps,
            qrbox: this.qrbox
        }

        this.html5QrCode = new Html5Qrcode('qr-camera', { formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE] })

        this.html5QrCode.start({ facingMode: 'environment' }, config, this.onScanSuccess).catch(err => {
            
            this.showQRScannerErrorMessage = true
        });

        if (navigator.userAgent.match('SamsungBrowser')) {
            this.isSamsungBrowser = true
        }

    },
    beforeDestroy () {
        this.html5QrCode.stop()
        this.showQRScannerErrorMessage = false
    },
    methods: {
        onScanSuccess (decodedText, decodedResult) {
            this.html5QrCode.pause()

            this.$emit('decode', decodedText, decodedResult)
        },
        resume () {
            this.html5QrCode.resume()
        }
    }
}
</script>
